import { Component, HostListener, inject } from '@angular/core';
import { OverlayService } from '../../overlay/overlay.service';
import { AlertaComponent } from '../alerta/alerta.component';
import { ExibeParaRotaDirective } from '../../../directives/exibe-para-rota.directive';
import { BotaoNavegaAoTopoComponent } from '../../botoes/botao-navega-ao-topo/botao-navega-ao-topo.component';
import { GuiaIndicadorComponent } from '../../guias/guia-indicador/guia-indicador.component';

@Component({
    selector: 'app-overlay',
    template: `
        <app-alerta />
        <ng-container *appExibeParaRota="['painel-indicadores']">
            <!-- <app-menu-filtro-indicadores /> -->
            <app-botao-navega-ao-topo />
            <app-guia-indicador />
        </ng-container>
    `,
    styleUrl: './overlay.component.scss',
    host: {
        'id': 'app-overlay',
        '[class.has-overlay]': 'overlayService.existeElementoDisposto()',
    },
    imports: [AlertaComponent, ExibeParaRotaDirective, BotaoNavegaAoTopoComponent, GuiaIndicadorComponent],
})
export class OverlayComponent {
    readonly overlayService = inject(OverlayService);

    @HostListener('click', ['$event'])
    public fechaElementoDisposto(event: MouseEvent): void {
        if (event.target === event.currentTarget) {
            this.overlayService.fecha();
        }
    }
}
